import React, { useEffect, useMemo, useRef, useState } from "react";
import { Link, useHistory } from 'react-router-dom';
import NavMenu from "./NavMenu";
import { CaretDownIcon, XIcon } from "@phosphor-icons/react";
import FlexColumn from "../../../components/FlexBox/FlexColumn";
import FlexRow from "../../../components/FlexBox/FlexRow";
import Typography from "../../../components/Typography/Typography";
import SideTooltip from "../../../components/Tooltip/SideTooltip";
import useIsMobile from "../../../hooks/useIsMobile";

const NavItems = ({ to = '', Icon, name = '', opened = false, showAd = false, adTitle = '', adDescription = '', adTo = '', onClick, children }) => {

    const history = useHistory();

    const anchorRef = useRef(null);
    const isMobile = useIsMobile();

    const [adStyle, setAdStyle] = useState({ main: {}, pointer: {} });
    const [menu, setMenu] = useState(false);
    const [expand, setExpand] = useState(false);

    const isActive = useMemo(() => {
        if (to === '/dashboard') {
            return history?.location?.pathname === to;
        } else {
            return history?.location?.pathname?.includes(to);
        }
    }, [children, to, history?.location?.pathname])

    useEffect(() => {
        if (isActive) {
            setExpand(true);
        } else {
            setExpand(false);
        }
    }, [isActive, opened])

    const hClick = () => {

        const navigate = () => {
            if (children) {
                setMenu(opened ? false : true)
            } else {
                history.push(to)
            }

            if (children && opened) {
                setExpand(!expand)
            }

            onClick && onClick();
        };

        if (isMobile && window.location.hash === "#sidebar") {

            const handlePop = () => {
                window.removeEventListener("popstate", handlePop);
                navigate();
            };

            window.addEventListener("popstate", handlePop);

            window.history.back();

        } else {
            navigate();
        }
    };

    useEffect(() => {
        let observer = null;
        let parentObs = null;
        let userSettingObs = null;
        if (showAd) {
            updateAdStyles();
            window.addEventListener("scroll", updateAdStyles, true);
            window.addEventListener("resize", updateAdStyles);
            observer = new ResizeObserver(updateAdStyles);

            if (anchorRef.current) observer.observe(anchorRef.current);

            parentObs = new ResizeObserver(updateAdStyles);
            if (anchorRef.current?.parentElement) {
                parentObs.observe(anchorRef.current.parentElement);
            }
            userSettingObs = new ResizeObserver(updateAdStyles);
            if (anchorRef.current?.parentElement?.parentElement?.firstElementChild) {
                userSettingObs.observe(anchorRef.current.parentElement.parentElement.firstElementChild);
            }
        }

        return () => {
            window.removeEventListener("resize", updateAdStyles);
            window.removeEventListener("scroll", updateAdStyles, true);
            observer?.disconnect();
            parentObs?.disconnect();
            userSettingObs?.disconnect();
        };
    }, [opened, showAd]);

    const updateAdStyles = () => {

        const rect = anchorRef.current.getBoundingClientRect();
        if (rect?.top + 100 > window.innerHeight) {
            let top = 40 + (rect?.top + 106) - window.innerHeight;
            setAdStyle(prev => ({
                pointer: {
                    top: `${top > 84 ? 95 : top}%`,
                    transform: top > 84 ? 'translateX(131%) rotate(-90deg)' : 'translateX(-50%)'
                },
                main: {
                    top: window.innerHeight,
                    transform: 'translateY(-110%)',
                    left: opened ? '17rem' : '5rem'
                }
            }))
        } else {
            setAdStyle(prev => ({
                pointer: {
                    top: '40%',
                    transform: 'translateX(-50%)'
                },
                main: {
                    top: rect?.top,
                    transform: 'translateY(-37%)',
                    left: opened ? '17rem' : '5rem'
                }
            }))
        }
    }

    return (
        <>
            <FlexColumn ref={anchorRef} flexWrap="nowrap" justifyContent="flex-start" gap="0.5rem" className="sn-nav-item">
                <SideTooltip title={(opened || isMobile) ? '' : name}>
                    <FlexRow onClick={hClick} gap="0.8rem" flexWrap="nowrap" justifyContent={name === '' ? "center" : "flex-start"} className={`${isActive ? 'active-item' : ''} nav-item main-container`} >
                        <p
                            style={{ color: "var(--grey-500)" }}
                            to={children ? null : to}>
                            {Icon}
                        </p>
                        <FlexRow flexWrap="nowrap" justifyContent="space-between" gap="0">
                            <Typography variant="b2B" className={`sidebar-toHide ellipsed-text ${opened ? 'sth-opened' : 'sth-closed'}`} color={isActive ? "var(--brand-500)" : "var(--grey-500)"}>{name}</Typography>
                            {children && <CaretDownIcon className={`carte-rotate-initial ${(opened && children && expand) ? 'cr-rotate' : ''}`} weight="bold" size={16} />}
                            {showAd && <div className='notification' style={{ backgroundColor: "var(--error-500)", width: '0.6rem', height: '0.6rem', top: '1.2rem', left: '1.8rem' }} />}
                        </FlexRow>
                    </FlexRow>
                </SideTooltip>
                {<FlexRow flexWrap="nowrap" styles={{ paddingLeft: '2rem', height: (opened && children && expand) ? `${39 * children?.filter(child => child)?.length}px` : '0px' }} className={`sub-container ${(opened && children && expand) ? 'sub-opened' : 'sub-closed'}`}>
                    <div style={{ width: '2px', height: '100%', background: "var(--grey-200)" }} />
                    <FlexColumn flexWrap="nowrap" gap="0.3rem">
                        {children}
                    </FlexColumn>
                </FlexRow>}

            </FlexColumn>
            <NavMenu anchorRef={anchorRef} open={menu && !opened} onClose={() => { setMenu(false) }}>
                {children}
            </NavMenu>
        </>
    )
}

export default NavItems;